import React from 'react';
import classNames from 'classnames';
import { TitleDivider } from '../title-divider';
import moment from 'moment';
import { CalendarItem } from '../calendar-item';

export class EventCalendar extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      events: this.props.events
    };
  }

  get className () {
    return classNames({
      'calendar': true
    })
  }

  componentDidMount () {
    this.sortEvents();
  }

  sortEvents = () => {
    const now = moment();

    var events = [...this.props.events];

    events.forEach(event => {
      if (event.eventSchedule) {
        if (event.eventSchedule[0].schedule) {
          event.startDate = new Date(event.eventSchedule[0].schedule[0].startDate);
        }
        
        event.hasPassed = event.eventSchedule.every(schedule => schedule.schedule && schedule.schedule.every(time => {
          const endTime = moment(time.endDate || time.startDate);
          return endTime.isBefore(now);
        }))
      }
    })

    events = events.sort((a, b) => a.startDate - b.startDate);

    this.setState({ events });
  }

  render () {
    return (
      <section className={this.className}>
        { this.state.events.map(event => <CalendarItem {...event} />) }
      </section>
    );
  }
}
